import React from 'react'

const Info = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M13 23.8332C18.9831 23.8332 23.8334 18.9829 23.8334 12.9998C23.8334 7.01675 18.9831 2.1665 13 2.1665C7.01694 2.1665 2.16669 7.01675 2.16669 12.9998C2.16669 18.9829 7.01694 23.8332 13 23.8332Z" opacity="0.5" stroke="currentColor" strokeWidth="1.8"></path>
<path d="M13 18.4165V11.9165" stroke="currentColor" strokeLinecap="round" strokeWidth="1.625"></path>
<path d="M13 7.58333C13.5983 7.58333 14.0834 8.06836 14.0834 8.66667C14.0834 9.26498 13.5983 9.75 13 9.75C12.4017 9.75 11.9167 9.26498 11.9167 8.66667C11.9167 8.06836 12.4017 7.58333 13 7.58333Z" fill="currentColor"></path>
</svg>
    )
}

export default Info
